import {
	Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges,
	SimpleChange, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { ConfigurationService } from 'configuration';


export class StringSelectorEntry {
	public dataKey: string;
	public value: string;

	constructor() {
		this.dataKey = "";
		this.value = "";
	}
}


@Component({
	selector: 'string-selector',
	templateUrl: './string-selector.component.html',
	styleUrls: ['./string-selector.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class StringSelectorComponent implements OnInit, OnChanges, OnDestroy {

	@Input()
	public header: string;

	@Input()
	public strings: string[];

	@Input()
	public selection: string[];

	@Input()
	public width: string;

	@Input()
	public scrollHeight: string;

	@Input()
	public disabled: boolean;

	@Output()
	public selectionChange: EventEmitter<string[]>;

	public cols: any[];
	public tableEntries: StringSelectorEntry[];
	public tableSelection: StringSelectorEntry[];

	constructor(private configService: ConfigurationService,	// This reference forces device categories to load
		private changeDetector: ChangeDetectorRef) {

		this.header = "";
		this.strings = [];
		this.selection = [];
		this.scrollHeight = "";
		this.selectionChange = new EventEmitter<string[]>();
		this.cols = [];
		this.tableEntries = [];
		this.tableSelection = [];
	}

	public doCustomSort(event): void {
		let comparer = function (a: StringSelectorEntry, b: StringSelectorEntry): number {
			let result = 0;

			switch (event.field) {
				default:
					// Compare string fields
					result = a[event.field].localeCompare(b[event.field]);
					break;
			}

			return result * event.order;
		}

		this.tableEntries.sort(comparer);
	}

	public ngOnInit(): void {

		this.cols = [
			{ field: 'value', header: this.header },
		];

		this.buildTableEntries();
		this.buildTableSelection();

		this.changeDetector.detectChanges();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.buildTableEntries();
		this.buildTableSelection();
	}

	public ngOnDestroy(): void {

	}

	private buildTableEntries(): void {
		this.tableEntries = [];
		this.strings.forEach((value: string) => {
			let entry = new StringSelectorEntry();

			entry.dataKey = value;
			entry.value = value;

			this.tableEntries.push(entry);
		}, this);
	}

	private buildTableSelection(): void {
		this.tableSelection = [];
		this.selection.forEach((selValue: string) => {
			let selEntry = this.findTableEntryByValue(selValue);
			if (selEntry) {
				this.tableSelection.push(selEntry);
			}
		}, this);
	}

	private findTableEntryByValue(value: string): StringSelectorEntry {
		return this.tableEntries.find(entry => entry.value == value);
	}

	public get selectedStringCount(): number {
		if (this.tableSelection) {
			if (Array.isArray(this.tableSelection)) {
				return this.tableSelection.length;
			}
			else {
				return 1;
			}
		}
		return 0;
	}

	public updateSelection(): void {
		this.selection = [];
		this.tableSelection.forEach((entry: StringSelectorEntry) => {
			this.selection.push(entry.value);
		}, this);
	}

	public onSelectionChange(event): void {
		this.updateSelection();
		this.selectionChange.emit(this.selection);
	}

}
